<app-select
  *ngIf="defaultEmailTemplate && user"
  placeholder="{{ 'appSelect.emailTemplate' | translate }}"
  [(ngModel)]="_document.email_template_id"
  [optionsRequest]="emailTemplatesRequest.bind(this)"
  [disabled]="user?.member?.group?.styles?.overwrite_email || !user?.subscription?.has_premium_features"
  [ngModelOptions]="{ standalone: true }"
  (ngModelChange)="selectEmailTemplate()"
></app-select>
